<script setup lang="ts">
import IconAngle from '@/components/icons/IconAngle.vue'
import { type InternalLinkType } from '@/types/app'
import { computed } from 'vue'

type ConditionalLink = InternalLinkType & {
  condition: boolean
}

const links = computed(() => {
  const conditionalLinks: ConditionalLink[] = [
    {
      text: 'メッセージ一斉配信',
      to: {
        name: 'chatMessageSendingJobIndex',
      },
      condition: true,
    },
    {
      text: 'ステップ配信',
      to: {
        name: 'StepDeliveryIndexPage',
      },
      condition: true,
    },
    {
      text: 'LINEリッチメニュー',
      to: {
        name: 'LineRichMenuIndexPage',
      },
      condition: true,
    },
  ]

  return conditionalLinks.filter(link => link.condition)
})
</script>

<template>
  <nav :class="$style.container">
    <section :class="[$style.menu, $style.container__menu]">
      <h2 :class="$style.title">配信</h2>
      <ul :class="$style.list">
        <li v-for="link in links" :key="link.text" :class="$style.list__item">
          <RouterLink
            :to="link.to"
            :class="$style.link"
            :active-class="$style['link--active']"
          >
            {{ link.text }}
            <IconAngle />
          </RouterLink>
        </li>
      </ul>
    </section>
  </nav>
</template>

<style lang="scss" module>
.container {
  &__menu {
    &:nth-child(n + 2) {
      margin-top: 16px;
    }
  }
}

.menu {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: $color-surface-primary;
  border-radius: $border-radius-v2-rounder;
  box-shadow: $shadow-4;
}

.title {
  font-size: 16px;
  font-weight: bold;
  margin: 20px 16px;
}

.list {
  &__item {
    border-top: 1px solid $color-border-low-emphasis;
  }
}

.link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding: 20px 16px;
  color: $color-text-and-object-high-emphasis;

  &:hover {
    text-decoration: none;
    color: $color-text-and-object-accent-primary;
  }

  &--active {
    background-color: $color-surface-accent-primary-light;
    color: $color-text-and-object-accent-primary;
    font-weight: 700;
  }
}
</style>
